import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query'
import { liveReportingQueryKeys } from 'src/queries/liveReporting/liveReporting.keys'
import {
  fetchLiveReportResult,
  fetchLiveReportSummaries,
} from 'src/queries/liveReporting/liveReporting.network'

const required = (value: string | undefined, name: string): string => {
  if (!value) throw new Error(`${name} is required`)
  return value
}

export interface LiveReportingQueryScope {
  actorId?: string
  organizationId?: string
  reportingEnabled?: boolean
}

export const liveReportingQueries = {
  summaries: ({
    actorId,
    organizationId,
    reportingEnabled = true,
  }: LiveReportingQueryScope) =>
    infiniteQueryOptions({
      queryKey: liveReportingQueryKeys.summaries(actorId, organizationId),
      queryFn: ({ pageParam, signal }) => {
        required(actorId, 'actorId')
        required(organizationId, 'organizationId')
        return fetchLiveReportSummaries({
          limit: 12,
          after: pageParam,
          signal,
        })
      },
      enabled: Boolean(reportingEnabled && actorId && organizationId),
      initialPageParam: undefined as string | undefined,
      getNextPageParam: (lastPage) => lastPage.next_cursor ?? undefined,
      refetchOnMount: true,
    }),
  result: ({
    actorId,
    organizationId,
    reportId,
    reportingEnabled = true,
    enabled = true,
  }: LiveReportingQueryScope & { reportId?: string; enabled?: boolean }) =>
    queryOptions({
      queryKey: liveReportingQueryKeys.result(
        actorId,
        organizationId,
        reportId,
        'live',
      ),
      queryFn: ({ signal }) => {
        required(actorId, 'actorId')
        required(organizationId, 'organizationId')
        return fetchLiveReportResult({
          reportId: required(reportId, 'reportId'),
          signal,
        })
      },
      enabled: Boolean(
        enabled && reportingEnabled && actorId && organizationId && reportId,
      ),
      refetchOnMount: true,
    }),
}
